/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name moment
 * @description Injectable wrapper for moment.js library.
 */
angular.module('aviApp').factory('moment', ['$window', function($window) {
    return $window.moment;
}]);
